import { Container, Grid } from '@mui/material';
import { FC, ReactNode } from 'react';

interface DocumentHeaderProps {
    children: ReactNode;
    lightHeader?: boolean;
    maxContentWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const DocumentHeader: FC<DocumentHeaderProps> = ({
    children,
    lightHeader,
    maxContentWidth = 'lg',
}) => {
    return (
        <Grid
            component="header"
            data-test-id="headerBar"
            justifyContent="center"
            sx={{
                backgroundColor: lightHeader ? 'common.white' : 'grey.100',
                py: 4,
            }}
            container
        >
            <Container maxWidth={maxContentWidth}>
                <Grid container>{children}</Grid>
            </Container>
        </Grid>
    );
};

export default DocumentHeader;
